module.exports = __webpack_public_path__ + "img/1.5e8238f9.jpg";